var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-layout',{staticClass:"layout"},[_c('app-navigation-panel'),_c('a-layout-content',{staticClass:"container"},[_c('div',{staticClass:"page-content"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }